export default {
  layout: {
    rows: [
      {
        fields: [ { name: "cp.sites" } ]
      },
      {
        fields: [ { name: "cp.cpSites" } ]
      },
      {
        fields: [ { name: "cp.title" } ]
      },
      {
        fields: [ { name: "cp.shortTitle" } ]
      },
      {
        fields: [ { name: "cp.code" } ]
      },
      {
        fields: [ { name: "cp.principalInvestigator" } ]
      },
      {
        fields: [ { name: "cp.coordinators" } ]
      },
      {
        fields: [
          { name: "cp.startDate" },
          { name: "cp.endDate" }
        ]
      },
      {
        fields: [ { name: "cp.irbId" } ]
      },
      {
        fields: [ { name: "cp.specimenCentric" } ]
      },
      {
        fields: [ { name: "cp.anticipatedParticipantsCount" } ]
      },
      {
        fields: [ { name: "cp.sopDocumentUrl" } ]
      },
      {
        fields: [ { name: "cp.sopDocumentName" } ]
      },
      {
        fields: [ { name: "cp.storeSprEnabled" } ]
      },
      {
        fields: [ { name: "cp.extractSprText" } ]
      }
    ]
  }
}
